import { CENTRA_PRICELIST_ID, type CentraPricelistId } from "@/data/centra-currency-id"
import {
    CENTRA_PRICELIST_CODE,
    type CentraPricelistCode
} from "@/data/supported-pricelists"

export type CountryCodeToCurrencyMap = Map<CentraPricelistCode, CentraPricelistId>

const centraPricelistCodeToCentraPricelistId: CountryCodeToCurrencyMap = new Map<
    CentraPricelistCode,
    CentraPricelistId
>([
    [CENTRA_PRICELIST_CODE.aud, CENTRA_PRICELIST_ID.aud],
    [CENTRA_PRICELIST_CODE.cad, CENTRA_PRICELIST_ID.cad],
    [CENTRA_PRICELIST_CODE.chf, CENTRA_PRICELIST_ID.chf],
    [CENTRA_PRICELIST_CODE.czk, CENTRA_PRICELIST_ID.czk],
    [CENTRA_PRICELIST_CODE.dkk, CENTRA_PRICELIST_ID.dkk],
    [CENTRA_PRICELIST_CODE.eur, CENTRA_PRICELIST_ID.eur],
    [CENTRA_PRICELIST_CODE.gbp, CENTRA_PRICELIST_ID.gbp],
    [CENTRA_PRICELIST_CODE.jpy, CENTRA_PRICELIST_ID.jpy],
    [CENTRA_PRICELIST_CODE.nok, CENTRA_PRICELIST_ID.nok],
    [CENTRA_PRICELIST_CODE.nzd, CENTRA_PRICELIST_ID.nzd],
    [CENTRA_PRICELIST_CODE.pln, CENTRA_PRICELIST_ID.pln],
    [CENTRA_PRICELIST_CODE.sek, CENTRA_PRICELIST_ID.sek],
    [CENTRA_PRICELIST_CODE.usd, CENTRA_PRICELIST_ID.usd]
])

export default centraPricelistCodeToCentraPricelistId
